// extracted by mini-css-extract-plugin
export default {"card":"r0-z","carouselContainer":"s0-z","carouselContent":"t0-z"};